import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionCircle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_39321_406660)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99076 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27289 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7118 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.5976 4.21903C10.117 4.13147 9.62309 4.1506 9.15074 4.27506C8.67839 4.39952 8.23917 4.62628 7.86416 4.93928C7.48915 5.25228 7.18751 5.64388 6.98059 6.08636C6.77367 6.52884 6.66653 7.01139 6.66675 7.49986C6.66675 7.72087 6.75455 7.93284 6.91083 8.08912C7.06711 8.2454 7.27907 8.33319 7.50008 8.33319C7.7211 8.33319 7.93306 8.2454 8.08934 8.08912C8.24562 7.93284 8.33342 7.72087 8.33342 7.49986C8.33321 7.25467 8.38709 7.01246 8.49124 6.79049C8.59539 6.56852 8.74723 6.37227 8.93593 6.21572C9.12463 6.05917 9.34555 5.94618 9.58294 5.88482C9.82032 5.82345 10.0683 5.81521 10.3092 5.86069C10.6384 5.9246 10.9411 6.08518 11.1786 6.32193C11.4161 6.55869 11.5776 6.86086 11.6426 7.18986C11.7082 7.5352 11.6629 7.89242 11.5132 8.21048C11.3635 8.52853 11.1171 8.79111 10.8092 8.96069C10.2994 9.25608 9.87807 9.68279 9.58919 10.1964C9.3003 10.7099 9.15442 11.2916 9.16675 11.8807V12.4999C9.16675 12.7209 9.25455 12.9328 9.41083 13.0891C9.56711 13.2454 9.77907 13.3332 10.0001 13.3332C10.2211 13.3332 10.4331 13.2454 10.5893 13.0891C10.7456 12.9328 10.8334 12.7209 10.8334 12.4999V11.8807C10.823 11.5907 10.8891 11.3031 11.0251 11.0468C11.1612 10.7905 11.3624 10.5745 11.6084 10.4207C12.2122 10.0891 12.6984 9.57857 13.0002 8.95936C13.3019 8.34015 13.4045 7.64266 13.2936 6.9628C13.1828 6.28294 12.8641 5.6541 12.3813 5.16277C11.8985 4.67144 11.2754 4.34175 10.5976 4.21903Z",
					fill: "currentColor"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.8334 14.9998C10.8334 14.5396 10.4603 14.1665 10.0001 14.1665C9.53984 14.1665 9.16675 14.5396 9.16675 14.9998C9.16675 15.4601 9.53984 15.8332 10.0001 15.8332C10.4603 15.8332 10.8334 15.4601 10.8334 14.9998Z",
					fill: "currentColor"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_39321_406660",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgQuestionCircle);
export default ForwardRef;
